module.exports = "<table>\n  <tr>\n    <td class=\"icon\">\n      <i class=\"material-icons\">report_problem</i>\n    </td>\n    <td class=\"content\">\n      <span>\n        {{data}}\n      </span>\n    </td>\n    <td class=\"close-icon\" style=\"padding-right: 5px;\">\n      <i (click)=\"closeToast()\" class=\"material-icons\" style=\"font-size: 18px;\">close</i>\n    </td>\n  </tr>\n</table>\n<div class=\"pgb-warning\"></div>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/shared/toast/warning/warning.component.html
// module id = ./src/app/shared/toast/warning/warning.component.html
// module chunks = main